<template>
  <table class="table is-bordered is-narrowed">
    <thead>
      <tr>
        <th>Pedido</th>
        <th>Tipo Docto.</th>
        <th>N&deg; Docto.</th>
        <th>Vendedor</th>
        <th>Pickeador</th>
        <th>Zona</th>
        <th>Tipo Pedido</th>
        <th>Entrega</th>
        <th>Estado</th>
        <th>Fecha</th>
        <th>Facturado</th>
        <th v-if="hayAcciones">
          <b-icon icon="cog" size="is-small" />
        </th>
      </tr>
    </thead>
    <tbody>
      <pedidos-item
        v-for="pedido in items"
        :key="`pedido-${pedido.id}`"
        :item="pedido"
        :modo="modo"
      />
      <tr v-if="!hayPedidos">
        <td class="has-text-centered" :colspan="numeroColumnas">
          No hay pedidos pendientes de entrega!
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapGetters } from 'vuex'

import PedidosItem from '@/components/monitorUsuario/PedidosItem'

export default {
  name: 'Pedidos',
  components: {
    PedidosItem
  },
  props: {
    modo: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega']),
    hayPedidos() {
      return this.items.length > 0
    },
    hayAcciones() {
      return (
        (this.bodega.puedeReimprimir || this.bodega.puedePickearVendedor) &&
        // Si usuario tiene rol Monitor, no se muestran acciones
        !this.bodega.roles.some((rol) => rol.id === 6)
      )
    },
    numeroColumnas() {
      const cols = 11
      if (this.hayAcciones) return cols + 1
      return cols
    },
    esUsuarioMonitor() {
      return false
    }
  }
}
</script>

<style></style>
